import { FC, PropsWithChildren, ReactNode, useId } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Checklist } from '@eneco/components/ui/Checklist/Checklist';
import { Price } from '@eneco/flows/components';
import { Box, Stack, Text, Badge, RadioCard, Divider } from '@eneco/sparky';

import { Price as PriceType } from '../../../shared/types';

interface Props {
  id: string;
  title?: string;
  ribbon?: ReactNode;

  price?: PriceType;

  tag?: string;
  usps?: string[];
}

//New productCard that mayber will replace the old Card. Is part of an A/b test
export const ProductCardRenewalFlow: FC<PropsWithChildren<Props>> = ({
  id: productId,
  title,
  ribbon,
  tag,
  price,
  usps,
  children,
}) => {
  const id = useId();

  return (
    <RadioCard value={productId} ariaLabelledby={`${id}-label ${id}-price`}>
      <Stack direction="column">
        <Stack.Item grow={true}>
          <Box backgroundColor="backgroundCMSVarFive" padding="3" borderTopLeftRadius="m" borderTopRightRadius="m">
            <Text color="textOnBackgroundVarFive" size="BodyS" weight="bold">
              Dynamisch en vast
            </Text>
          </Box>
          {ribbon && <Box overflow="hidden">{ribbon}</Box>}

          <Box padding="6" paddingBottom="3">
            <Stack gap="6">
              <Stack direction="row" alignX="justify" gap="2">
                <Stack direction="row" gap="2" alignY="start">
                  <Stack.Item shrink={false}>
                    <Box paddingTop="1">
                      <RadioCard.Indicator />
                    </Box>
                  </Stack.Item>

                  {title && (
                    <Text id={`${id}-label`} weight="bold">
                      {title}
                    </Text>
                  )}
                </Stack>
              </Stack>

              {tag && (
                <Stack.Item>
                  <Badge color="alpha">{tag}</Badge>
                </Stack.Item>
              )}

              {usps && (
                <Checklist>
                  {usps.map(usp => (
                    <Checklist.Item key={usp} gap="2">
                      <Stack>
                        <RichText html={usp} />
                      </Stack>
                    </Checklist.Item>
                  ))}
                </Checklist>
              )}
              {price && (
                <Stack gap="2" alignY="start" direction="row">
                  <Stack.Item>
                    <Text size="BodyM" weight="bold">
                      <Price id={`${id}-price`}>{price.value}</Price>
                    </Text>
                  </Stack.Item>
                  <Stack.Item>
                    <Text>{price.period}</Text>
                  </Stack.Item>
                </Stack>
              )}
            </Stack>
          </Box>
        </Stack.Item>

        {children && (
          <Stack.Item>
            <Divider />
            {children}
          </Stack.Item>
        )}
      </Stack>
    </RadioCard>
  );
};
